import { AppState } from 'types';

export const APP_STATE_STORAGE_KEY = 'tb-app-state';

export const DEFAULT_APP_STATE: AppState = {
  drawer: {
    desktopCollapsed: false,
  },
};
